import React from "react";
import { Card, CardBody, Row, Col, FormGroup, Label, Button } from "reactstrap";
import { useMutation } from "@apollo/client";
import { useHistory } from "react-router-dom";
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";
import { USER_CREATE_MUTATION, USER_LIST_QUERY } from "../../config/Queries";

function parseDateInputToLocalMs(dateStr) {
  if (!dateStr) return null;
  const [y, m, d] = String(dateStr).split("-").map((v) => parseInt(v, 10));
  if (!Number.isFinite(y) || !Number.isFinite(m) || !Number.isFinite(d)) return null;
  const ms = new Date(y, m - 1, d, 0, 0, 0, 0).getTime();
  return Number.isFinite(ms) ? ms : null;
}

function PatientWrite() {
  const history = useHistory();
  const { register, handleSubmit } = useForm();

  const [createAccount, { loading }] = useMutation(USER_CREATE_MUTATION, {
    awaitRefetchQueries: true,
    refetchQueries: () => [
      {
        query: USER_LIST_QUERY,
        variables: { type: "환자" },
      },
    ],
  });

  const onSubmit = async (form) => {
    try {
      const joinDateMs = parseDateInputToLocalMs(form.createdAtDate);
      const { data } = await createAccount({
        variables: {
          userId: form.userId,
          userType: "환자",
          userName: form.userName,
          password: form.password,
          sex: form.sex || null,
          phone: form.phone,
          createdAt: Number.isFinite(joinDateMs) ? String(joinDateMs) : null,
          residentNumber: (form.residentNumber || "").trim() || null,
        },
      });

      if (!data?.createAccount?.ok) {
        throw new Error(data?.createAccount?.error || "등록에 실패했습니다.");
      }

      toast.success("환자 회원 등록이 완료되었습니다.", {
        autoClose: 3000,
        position: toast.POSITION.TOP_RIGHT,
      });
      history.push("/admin/patients");
    } catch (e) {
      toast.error(e?.message || "환자 회원 등록 중 오류가 발생했습니다.", {
        autoClose: 3000,
        position: toast.POSITION.TOP_RIGHT,
      });
    }
  };

  return (
    <div className="content">
      <form onSubmit={handleSubmit(onSubmit)}>
        <Card>
          <div className="card-heading">환자 회원 등록</div>
          <CardBody>
            <FormGroup row>
              <Label for="userId" sm={2} className="control-label">
                아이디
              </Label>
              <Col sm={10}>
                <input
                  id="userId"
                  name="userId"
                  className="form-control"
                  placeholder="아이디를 입력해주세요."
                  type="text"
                  ref={register({ required: "아이디를 입력해주세요." })}
                />
              </Col>
            </FormGroup>

            <FormGroup row>
              <Label for="password" sm={2} className="control-label">
                비밀번호
              </Label>
              <Col sm={10}>
                <input
                  id="password"
                  name="password"
                  className="form-control"
                  placeholder="비밀번호를 입력해주세요."
                  type="password"
                  ref={register({ required: "비밀번호를 입력해주세요." })}
                />
              </Col>
            </FormGroup>

            <FormGroup row>
              <Label for="userName" sm={2} className="control-label">
                이름
              </Label>
              <Col sm={10}>
                <input
                  id="userName"
                  name="userName"
                  className="form-control"
                  placeholder="이름을 입력해주세요."
                  type="text"
                  ref={register({ required: "이름을 입력해주세요." })}
                />
              </Col>
            </FormGroup>

            <FormGroup row>
              <Label for="sex" sm={2} className="control-label">
                성별
              </Label>
              <Col sm={4}>
                <select id="sex" name="sex" className="form-control" ref={register()}>
                  <option value="">선택 안 함</option>
                  <option value="남자">남자</option>
                  <option value="여자">여자</option>
                </select>
              </Col>

              <Label for="phone" sm={2} className="control-label">
                연락처
              </Label>
              <Col sm={4}>
                <input
                  id="phone"
                  name="phone"
                  className="form-control"
                  placeholder="숫자만 입력 (예: 01012345678)"
                  type="text"
                  ref={register({ required: "연락처를 입력해주세요." })}
                />
              </Col>
            </FormGroup>

            <FormGroup row>
              <Label for="residentNumber" sm={2} className="control-label">
                주민등록번호
              </Label>
              <Col sm={10}>
                <input
                  id="residentNumber"
                  name="residentNumber"
                  className="form-control"
                  placeholder="주민등록번호"
                  type="text"
                  ref={register()}
                />
              </Col>
            </FormGroup>

            <FormGroup row>
              <Label for="createdAtDate" sm={2} className="control-label">
                가입일
              </Label>
              <Col sm={10}>
                <input
                  id="createdAtDate"
                  name="createdAtDate"
                  className="form-control"
                  type="date"
                  ref={register()}
                />
              </Col>
            </FormGroup>
          </CardBody>
        </Card>

        <Row>
          <Col xs={4} className="text-left">
            <Button
              onClick={() => history.push("/admin/patients")}
              className="btn-white"
              type="button"
              disabled={loading}
            >
              <i className="fa fa-list"></i>
              목록
            </Button>
          </Col>
          <Col xs={4} className="text-center">
            <Button type="submit" className="btn-inverse" disabled={loading}>
              <i className="fa fa-check"></i>
              확인
            </Button>
          </Col>
          <Col xs={4} className="text-right"></Col>
        </Row>
      </form>
    </div>
  );
}

export default PatientWrite;

